// Claro / oscuro. Por defecto sigue al teléfono; si la persona elige uno en
// Ajustes queda fijo en este dispositivo. Se aplica poniendo data-theme en
// <html> (los colores viven en theme/variables.css).
export type ThemePreference = 'system' | 'light' | 'dark';
export type Theme = 'light' | 'dark';

const KEY = 'domiot:theme';
// Color de la barra del sistema (Android / PWA) en cada modo.
const BAR_COLOR: Record<Theme, string> = { light: '#4F7A5C', dark: '#0b0d0a' };

const systemQuery = () => window.matchMedia?.('(prefers-color-scheme: dark)');

export function getThemePreference(): ThemePreference {
  try {
    const saved = localStorage.getItem(KEY);
    return saved === 'light' || saved === 'dark' ? saved : 'system';
  } catch {
    return 'system';
  }
}

function resolveTheme(pref: ThemePreference = getThemePreference()): Theme {
  if (pref !== 'system') return pref;
  return systemQuery()?.matches ? 'dark' : 'light';
}

function apply() {
  const theme = resolveTheme();
  const root = document.documentElement;
  if (root.dataset.theme === theme) return;
  // Sin animaciones de color durante el cambio: si no, cada botón pasa
  // un instante por gris.
  root.classList.add('theme-switching');
  root.dataset.theme = theme;
  root.style.colorScheme = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', BAR_COLOR[theme]);
  requestAnimationFrame(() => requestAnimationFrame(() => root.classList.remove('theme-switching')));
}

export function setThemePreference(pref: ThemePreference): void {
  try {
    if (pref === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, pref);
  } catch {
    // Sin storage (navegación privada): vale para esta sesión nada más.
  }
  apply();
}

// Una vez al arrancar: aplica el tema y sigue los cambios del teléfono
// (por ejemplo, el modo oscuro automático al anochecer).
export function initTheme(): void {
  apply();
  systemQuery()?.addEventListener?.('change', apply);
}

